/**
 * Created by sven.bluege on 04.04.2017.
 */

require('./frontend/less/responsive-static.less');
